import React from 'react';
import '../Top.css';
import '../Layout.css'
import '../index.css'

export default class Arrow extends React.Component {
    render() {
        return (
            <>
                <div className="arrow">
                    <span>Day: 21</span>
                    <div className="dayArrow">
                    <div className="dayArrowTriangle" />
                    </div>
                    <span className="dayTextR">Day: 31</span>
                </div>
            </>
        )
    }
};
